import { render } from "./RingkasanPenjualan.vue?vue&type=template&id=5da5d83f&scoped=true"
import script from "./RingkasanPenjualan.vue?vue&type=script&lang=js"
export * from "./RingkasanPenjualan.vue?vue&type=script&lang=js"

import "./RingkasanPenjualan.vue?vue&type=style&index=0&id=5da5d83f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5da5d83f"

export default script